<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Documents",
    }
</script>

<style scoped>

</style>